// Copy to clipboard
function copyToClipboard(text, showTooltip = true) {
  navigator.clipboard
    .writeText(text)
    .then(function () {
      console.log("Text copied to clipboard");
    })
    .catch(function (error) {
      console.error("Error copying text: ", error);
    });

  if (showTooltip) {
    const tooltip = document.createElement("div");
    const toolTipContainer = document.querySelector(".tooltip-container");
    tooltip.classList.add("tooltip");
    tooltip.classList.add("text-xs");
    tooltip.textContent = "Copied to clipboard";
    toolTipContainer.appendChild(tooltip);

    setTimeout(() => {
      if (tooltip) {
        console.log("Removing tooltip:", tooltip);
        tooltip.remove();
      } else {
        console.error("Tooltip element not found");
      }
    }, 2000);
  }
}
